<template>
  <textarea
    ref="textarea"
    class="form-textarea"
    v-model="$attrs.modelValue"
    v-bind="$attrs"
    :rows="rows"
  />
</template>

<script>
import { ref } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    rows: {
      type: [String, Number],
      default: 4,
    }
  },
  setup() {
    const textarea = ref();

    function focus() {
      textarea.value.focus();
    }

    function select() {
      textarea.value.select();
    }

    function setSelectionRange(start, end) {
      textarea.value.setSelectionRange(start, end);
    }

    return {
      textarea,
      focus,
      select,
      setSelectionRange,
    }
  }
}
</script>
